document.addEventListener('DOMContentLoaded', function () {
  const popupElement = document.getElementById('size-guide-section');
  const popupContent = document.querySelector('[data-modal-content-holder]');
  if (popupElement && popupContent) {
    popupContent.innerHTML = popupElement.innerHTML;
  }
  const parentElement = popupContent ? popupContent : document.getElementById('MainContent');
  const tabLinks = parentElement.querySelectorAll('.size-guide__tablink');
  const tabContentElements = parentElement.querySelectorAll('.size-guide__tabcontent');
  const switchElements = parentElement.querySelectorAll('.size-guide__switch');
  const inchElements = parentElement.querySelectorAll('.size-guide__inch');
  const cmElements = parentElement.querySelectorAll('.size-guide__cm');
  const switchContainers = parentElement.querySelectorAll('.size-guide__switch-container');
  tabLinks.forEach((element) => {
    element.addEventListener('click', () => {
      const activeTab = element.getAttribute('data-tab-name');
      tabLinks.forEach((link) => {
        link.classList.remove('_active');
      });
      tabContentElements.forEach((el) => {
        el.id === activeTab ? el.classList.add('_opened') : el.classList.remove('_opened');
      })
      element.classList.add('_active');
      switchContainers.forEach((item) => {
        item.style.display = activeTab !== 'size-chart' ? 'none' : 'flex';
      })
    })
  })
  switchElements.forEach((element) => {
    element.addEventListener('click', () => {
      switchElements.forEach((item) => {
        item.classList.remove('_active');
      })
      element.classList.add('_active');
      if (element.getAttribute('data-swith-value') === 'inches') {
        inchElements.forEach((item) => {
          item.style.display = 'block'
        })
        cmElements.forEach((item) => {
          item.style.display = 'none'
        })
      } else {
        inchElements.forEach((item) => {
          item.style.display = 'none'
        })
        cmElements.forEach((item) => {
          item.style.display = 'block'
        })
      }
    })
  })
})
